export default __webpack_public_path__ + "static/152-239ff7cbd01939e2cf87f3974957bd4e.jpg";